export const tagColors = ['#1DBD6B', '#FD2020', '#FD5E20', '#6457E8', '#35AAEC'];